/**
 * Detects if the application is running inside an Electron shell.
 * This works in dev, test, and production environments.
 *
 * @returns {boolean} True if running in Electron, false if in a standard browser.
 */
export const isElectron = (): boolean => {
  // 1. Check the User Agent for "Electron"

  const isElectronApp = !!(window as any).electronApp;
  if (isElectronApp) {
    return true;
  }

  if (
    typeof window !== "undefined" &&
    window.navigator &&
    window.navigator.userAgent.indexOf("Electron") >= 0
  ) {
    return true;
  }

  if (
    typeof window !== "undefined" &&
    (window as any).process &&
    (window as any).process.type === "renderer"
  ) {
    return true;
  }

  return false;
};

/**
 * Example usage for environment-based configuration.
 * You can expand this to return different base URLs, API keys, etc.
 */
export const getEnvConfig = () => {
  if (isElectron()) {
    return {
      type: "shell",
    };
  }

  return {
    type: "web",
  };
};

export const isElectronApp = () => {
  return isElectron();
};

export const getGoogleAnalyticsId = (): string => {
  if (
    typeof window !== "undefined" &&
    (window as any).electronApp?.envConfig?.googleAnalyticsId
  ) {
    return (window as any).electronApp.envConfig.googleAnalyticsId;
  }
  return import.meta.env.VITE_GOOGLE_ANALYTICS_ID || "";
};

export const getAppOrigin = (): string => {
  if (
    typeof window !== "undefined" &&
    (window as any).electronApp?.envConfig?.origin
  ) {
    return (window as any).electronApp.envConfig.origin;
  }
  return "";
};

/**
 * Checks if the new landing portal is enabled via environment toggle.
 * Defaults to false (old landing flow) unless explicitly enabled.
 */
export const isNewLandingEnabled = (): boolean => {
  const landingFlag = import.meta.env.VITE_ENABLE_NEW_LANDING;
  const enableFlag = import.meta.env.VITE_ENABLE_NEW_LANDING_POC;
  const pocFlag = import.meta.env.VITE_NEW_LANDING_POC;
  const landingVer = import.meta.env.VITE_LANDING_VERSION;

  return (
    landingFlag === "true" ||
    landingFlag === true ||
    pocFlag === "true" ||
    pocFlag === true ||
    enableFlag === "true" ||
    enableFlag === true ||
    landingVer === "new" ||
    landingVer === "v2" ||
    landingVer === "poc"
  );
};

export const isNewLandingPOC = isNewLandingEnabled;
